import styled from 'styled-components';
import { IonAccordionGroup } from '@ionic/react';

export const Root = styled(IonAccordionGroup)`
  .ion-accordion-toggle-icon {
    color: ${({ theme }) => theme.palette.brown400};
  }
`;
